import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { apiRequest } from "../../api/apiService";
import "./rootPoolDetail.scss";
import Loader from '../../shared/Loader';

// Components
import PoolHeader from "./components/PoolHeader";
import PoolStats from "./components/PoolStats";
import PoolFilters from "./components/PoolFilters";
import PoolTable from "./components/PoolTable";
import PoolMobileView from "./components/PoolMobileView";
import ShareModal from "./components/ShareModal";
import { useTheme } from "../../hooks/ThemeProvider";
import { ApiUrl } from "../../utils/ApiUrl";
import PaginationSection from "../../shared/PaginationSection";
const RootPoolDetail = () => {
  const { theme, toggle } = useTheme();
  const [rootPoolData, setRootPoolData] = useState([]);
  const [childPools, setChildPools] = useState([]);
  // const [rootPoolData, setRootPoolData] = useState();
  // const [childPools, setChildPools] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (!loading && childPools.length === 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [loading, childPools]);

  // ✅ Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [filters, setFilters] = useState({ search: "", sortBy: "" });


  const [totalTvl, setTotalTvl] = useState(0);
  const [link, setLink] = useState("activepools");
  const [modalData, setModalData] = useState();

  // ✅ Fetch child pools (paginated)
  const fetchPoolCreateds = async (contractAddress, page = 1, limit = 10, filters = {}) => {
    setLoading(true);
    try {
      const offset = (page - 1) * limit;

      const data = await apiRequest({
        url: `${ApiUrl}/pool/child-pools?contractAddress=${contractAddress}`,
        method: "GET",
        params: {
          offset,
          limit,
          search: filters.search?.toLowerCase() || undefined,
          sort: filters.sortBy || undefined,
        },
        auth: false,
      });

      setChildPools(data?.data?.items || []);
      setTotalItems(data?.data?.pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching child pools:", error);
    } finally {
      setLoading(false);
    }
  };



  // ✅ Fetch root pool details
  const fetchRootPoolDetail = async () => {
    setLoading(true);
    try {
      const data = await apiRequest({
        url: `${ApiUrl}/pool/root-pool/${id}`,
        method: "GET",
        auth: false,
      });
      setRootPoolData(data?.data);
    } catch (error) {
      console.error("Error fetching root pool:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ When rootPoolData or pagination changes → refetch child pools
  useEffect(() => {
    if (rootPoolData?.contractAddress) {
      fetchPoolCreateds(rootPoolData.contractAddress, currentPage, perPage, filters);
    }
  }, [rootPoolData, currentPage, perPage, filters]);


  useEffect(() => {
    if (id) {
      fetchRootPoolDetail();
    }
  }, [id]);

  // ✅ Share Modal Handlers
  const handleShowShareModal = (data, flag = false) => {
    if (flag) {
      setLink("stakingpool");
      setModalData({
        ...data,
        projectLogo: rootPoolData?.projectLogo,
        projectName: rootPoolData?.projectName,
        tagline: rootPoolData?.tagline,
      });
    } else {
      setLink("activepools");
      setModalData(data);
    }
    setShowShareModal(true);
  };

  const handleCloseShareModal = () => setShowShareModal(false);

  return (
    <>
      {loading && <Loader />}
      <section className="future_main">
        <div className="layer_imggggs">
          <div className="imgdarklight">
            {
              theme === 'dark' ? <img src="/assets/detailshade.png" className="imgdarklightt lassst" />
                : <img src="/assets/bgggg.png" alt="Logo" className="imgdarklightt" />
            }
          </div>


          {/* <img src={rootPoolData?.metadata?.logo ? rootPoolData?.metadata?.logo : theme === 'dark' ? "/assets/detailshade.png" : "/assets/bgggg.png"} className="detailshade" />
          <img src={rootPoolData?.projectLogo ? rootPoolData?.projectLogo : theme === 'dark' ? "/assets/detailshade.png" : "/assets/bgggg.png"} className="detailshade" /> */}
        </div>

        {/* <img
          src={rootPoolData?.projectLogo || "/assets/detailshade.png"}
          className="detailshade"
          alt="Pool Detail"
        /> */}
        {/* <div className="mblparent">
          <img src="/mblbanner.png" alt="banner" className="img-fluid shadembl d-none" />
        </div> */}

        <div className="custom-container">
          <div className="inner_future">
            <PoolHeader onShare={handleShowShareModal} rootPoolData={rootPoolData} />
            <PoolStats rootPoolData={rootPoolData} totalTvl={totalTvl} />
            <PoolFilters onFilterChange={setFilters} />

            {/* ✅ Desktop Table */}
            <PoolTable
              rootPoolData={rootPoolData}
              loading={loading}
              onShare={handleShowShareModal}
              childPools={childPools}
            />

            {/* ✅ Mobile Accordion */}
            <PoolMobileView pools={childPools} onShare={handleShowShareModal} rootPoolData={rootPoolData} />

            {/* ✅ Pagination Section */}
            <PaginationSection
              currentPage={currentPage}
              totalItems={totalItems}
              perPage={perPage}
              onPageChange={setCurrentPage}
              onPerPageChange={(val) => {
                setPerPage(val);
                setCurrentPage(1); // Reset to first page when limit changes
              }}
            />
          </div>
        </div>
      </section>

      <ShareModal
        show={showShareModal}
        onHide={handleCloseShareModal}
        rootPoolData={modalData}
        link={link}
      />
    </>
  );
};

export default RootPoolDetail;
